import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';
import { CommonService } from '../../../services/common.service';
import { LangService } from 'src/app/core/services/lang.service';
import { GridService } from 'src/app/shared/services/grid.service';
@Component({
  selector: 'app-cheque-no',
  templateUrl: './../../../templates/forms/modals/cheque-no.component.html',
})
export class ChequeNoComponent implements OnInit {
  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  searchFields: any[] = ['CHEQUE_NO'];
  public searchString;

  dataObj: any;

  chequeList: any[] = [];
  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "ChequeNoGrid"

  constructor(public langService: LangService,
    private comService: CommonService,
    public gridService: GridService) {
    this.colObj = [
      { headerName: langService.langData.chequeNo, field: 'CHEQUE_NO', sortable: true, resizable: true, hide: false },
    ];
  }
  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);
    this.comService.getChequeNo().subscribe(result => {
      this.chequeList = result.body;
      console.log("cheque list", this.chequeList);
    })
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;
    this.submit.next();
  }

}
